import { Router, Route, ActivatedRouteSnapshot } from '@angular/router';
import { inject } from '@angular/core';
import { decryptPledgeData } from 'src/app/shared/crypto-js/crypto-js';

export const moduleAccessGuard = (route: Route | ActivatedRouteSnapshot) => {
    const router = inject(Router);

    const show_pop_up = sessionStorage.getItem('show_pop_up') === 'true';
    if (show_pop_up) {
        if (router.url !== '/dashboard') {
            router.navigate(['/financial-proof']);
        }
        return false;
    }

    const encryptedUserSession = localStorage.getItem('encryptedUserSession');
    const decryptedData = encryptedUserSession ? JSON.parse(decryptPledgeData(encryptedUserSession)) : null;
    const clientId = decryptedData?.accountId;

    const allowedClientIds = route.data?.['allowedClientIds'];
    if (allowedClientIds && !clientId) {
        router.navigate(['/tradejournals']);
        return false;
    }

    if (allowedClientIds && !allowedClientIds.includes(clientId)) {
        router.navigate(['/tradejournals']);
        return false;
    }

    return true;
};